import type { RichTextElementCustomProps } from "./RichTextElement"
import type { TextProps } from "@jobteaser/spark/components/Text"
import type { FunctionComponent } from "react"

import { nodeParse } from "@kontent-ai/rich-text-resolver"

import { Text } from "@jobteaser/spark/components/Text"

import { RichTextElement } from "./RichTextElement"

type RichTextProps = RichTextElementCustomProps & {
  html: string
  wrapperProps?: TextProps
}

export const RichTextFromHtml: FunctionComponent<RichTextProps> = ({
  customComponents,
  html,
  tagComponents,
  wrapperProps = { variant: "body1" },
}) => {
  const { children: value } = nodeParse(html)

  return (
    <Text {...wrapperProps}>
      {value.map((elementProps, index) => (
        <RichTextElement
          {...elementProps}
          customComponents={customComponents}
          // eslint-disable-next-line react/no-array-index-key
          key={`${elementProps.type}_${index}`}
          tagComponents={tagComponents}
        />
      ))}
    </Text>
  )
}
